import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './route.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Route } from "model/system/route.model";

export interface RouteDetailsProps extends DetailsStateAndDispatchProps<Route, 'keyDataType'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const RouteDetails: FC<RouteDetailsProps> = (props) => {
  return (
    <DetailsPage<Route, 'keyDataType'>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Route, 'keyDataType'>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ route }: RootState) => ({
  entity: route.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RouteDetails);
